import { render } from "./ProductPrice.vue?vue&type=template&id=59475b7c&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"

import "./ProductPrice.vue?vue&type=style&index=0&id=59475b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59475b7c"]])

export default __exports__